module.exports = __webpack_public_path__ + "static/img/11.9077cd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pro/air/11.png
// module id = UywW
// module chunks = 0